import i from"react";import o from".";const t=({children:r,className:n,...e})=>i.createElement(o,{underline:"none",...e},r);var h=t;export{t as ImperceptibleLink,h as default};
//# sourceMappingURL=imperceptible.js.map
